/** Polyfilling some common methods that are post-ES6 and not available in IE11 */

/** Polyfill for Object.values */
export function objectValues<T>(obj: { [K: string]: T }): T[] {
  const keys = Object.keys(obj);
  return keys.map(key => obj[key]);
}
